import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobAlertSettingsSupplierComponent } from './job-alert-settings-supplier.component';
import { JobAlertSettingsEditModule } from './job-alert-settings-edit.module';
import { RedirectTermConditionGuard } from 'src/app/guards/redirect-term-condition.guard';

const routes: Routes = [
  {
    path: '',
    component: JobAlertSettingsSupplierComponent,
    data: { title: 'Job Notification Settings' },
    canActivate: [RedirectTermConditionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobAlertSettingsAdminRoutingModule {}

@NgModule({
  imports: [
    JobAlertSettingsAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    JobAlertSettingsEditModule,
  ],
  declarations: [JobAlertSettingsSupplierComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobAlertSettingsSupplierModule {}
